import { Flex, Tooltip, Typography } from '@project44/manifest-ds';

const style = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: 'fit-content',
};

interface ICellLocation {
  locationName?: string;
  cityState?: string;
}

function CellLocation({ locationName, cityState }: ICellLocation) {
  return (
    <Flex
      data-testid="location-cell"
      orientation="vertical"
      gap="x-small"
      css={{ pointerEvents: 'none' }}
    >
      <Tooltip title={locationName}>
        <Typography variant="subtextBold" css={style}>
          {locationName || '-'}
        </Typography>
      </Tooltip>
      <Tooltip title={cityState}>
        <Typography variant="subtext" css={style}>
          {cityState || '-'}
        </Typography>
      </Tooltip>
    </Flex>
  );
}

export default CellLocation;
